var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","disabled":!_vm.item.active,"loading":_vm.loading.active},on:{"click":_vm.setActive}},[_c('v-icon',[_vm._v("mdi-bank"+_vm._s(!_vm.item.active ? "-off" : ""))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }